import { initializePaddle } from '@paddle/paddle-js'

export default {
  async install(app) {
    try {
      // Working only in production environment
      await initializePaddle({
        environment: 'production',
        token: __PADDLE_TOKEN__
      })

      app.config.globalProperties.$paddle = window.Paddle
      app.provide('paddle', window.Paddle)
    } catch (error) {
      console.error('Failed to initialize Paddle:', error)
      throw error
    }
  }
}
